import { apiClient } from "@/api/api-client.ts";

const counselsService = {
	getCounselInfo: async (rollNumber) => {
		const response = await apiClient.get<{ data: T[]; meta: Pagination }>(`/counsel-info/${rollNumber}`);

		return response.data;
	},
};

export default counselsService;
